/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DtoTravelDonationCreate } from '../../models/dto-travel-donation-create';
import { TravelBookingCreateResponseRedirect } from '../../models/travel-booking-create-response-redirect';

export interface TravelControllerCreateTravelDonation$Params {
  id: number;
      body: DtoTravelDonationCreate
}

export function travelControllerCreateTravelDonation(http: HttpClient, rootUrl: string, params: TravelControllerCreateTravelDonation$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelBookingCreateResponseRedirect;
}>> {
  const rb = new RequestBuilder(rootUrl, travelControllerCreateTravelDonation.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TravelBookingCreateResponseRedirect;
      }>;
    })
  );
}

travelControllerCreateTravelDonation.PATH = '/travel/{id}/donate';
